import '../../../polyfills';
import WebpackerReact from 'webpacker-react';

import { MembershipPlanCards } from '../../../MembershipPlanCards';

WebpackerReact.setup({
  MembershipPlanCards,
});
